import { useEffect, useState } from "react";
import { getEnvases, getProductosEnvasados } from "../services/productosService";
import {
  crearLineaEnvase,
  crearLineaVacia,
  esPromoOSena,
  marcarPromoSena,
  tieneOtraPromo as tieneOtraPromoUtil,
} from "../utils/lineas";

// Núcleo compartido por Nuevo Pedido y Editar Pedido: productos y envases
// disponibles, líneas del pedido y sus cambios.
// - "tabla" se recibe porque se vuelven a pedir los productos al volver de los
//   sub-modales (igual que el original).
// - "onLineaEliminada" (opcional) avisa qué línea se borró; Editar Pedido lo usa
//   para dar de baja los renglones que ya existían.
export const useLineas = ({ uuidPedido, tabla, onLineaEliminada }) => {
  const [productos, setProductos] = useState();
  const [envases, setEnvases] = useState([]);
  const [datosRenglon, setDatosRenglon] = useState([]);

  useEffect(() => {
    getProductosEnvasados().then(setProductos);
  }, [tabla]);

  useEffect(() => {
    getEnvases()
      .then(setEnvases)
      .catch((error) => {
        // Sin la lista de envases el resto del formulario sigue funcionando.
        console.error("Error cargando envases:", error);
        setEnvases([]);
      });
  }, []);

  const agregarLinea = () => {
    setDatosRenglon((prevLineas) => [...prevLineas, crearLineaVacia(uuidPedido)]);
  };

  const agregarEnvase = () => {
    setDatosRenglon((prevLineas) => [...prevLineas, crearLineaEnvase(uuidPedido)]);
  };

  // Es envase si se agregó con "+ Envase", si vino marcado como envase o si su
  // producto es un envase (cubre predeterminados que sean envases).
  const esLineaEnvase = (linea) =>
    linea.tipo === "envase" ||
    (linea.producto !== null && envases.some((e) => e.idproducto === linea.producto));

  const handleProductoChange = (index, value) => {
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].producto = value ? value.idproducto : null;
    // Si la línea era promo/seña y el nuevo producto ya tiene una en otra
    // línea, se le quita la marca para respetar "una promo por producto".
    if (esPromoOSena(nuevasLineas[index]) && tieneOtraPromoUtil(nuevasLineas, index)) {
      nuevasLineas[index] = marcarPromoSena(nuevasLineas[index], false);
    }
    setDatosRenglon(nuevasLineas);
  };

  const handleCantidadChange = (index, value) => {
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].cantidad = value;
    setDatosRenglon(nuevasLineas);
  };

  const handleEspecificacionesChange = (index, value) => {
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].especificaciones = value;
    setDatosRenglon(nuevasLineas);
  };

  const handlePromoSenaChange = (index, checked) => {
    // Los envases no admiten promo/seña (igual que en la app).
    if (checked && esLineaEnvase(datosRenglon[index])) return;
    if (checked && tieneOtraPromoUtil(datosRenglon, index)) return;
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index] = marcarPromoSena(nuevasLineas[index], checked);
    setDatosRenglon(nuevasLineas);
  };

  const tieneOtraPromo = (index) => tieneOtraPromoUtil(datosRenglon, index);

  const eliminarLinea = (index) => {
    if (onLineaEliminada) onLineaEliminada(datosRenglon[index]);
    setDatosRenglon(datosRenglon.filter((_, i) => i !== index));
  };

  // Busca en productos y en envases (una línea puede tener cualquiera de los dos).
  const getProductoById = (id) =>
    (productos && productos.find((producto) => producto.idproducto === id)) ||
    envases.find((envase) => envase.idproducto === id) ||
    null;

  return {
    productos,
    envases,
    datosRenglon,
    setDatosRenglon,
    agregarLinea,
    agregarEnvase,
    esLineaEnvase,
    eliminarLinea,
    handleProductoChange,
    handleCantidadChange,
    handleEspecificacionesChange,
    handlePromoSenaChange,
    tieneOtraPromo,
    getProductoById,
  };
};
